// extracted by mini-css-extract-plugin
export default {"table":"shareableLinks_table__NHvK6","tr":"shareableLinks_tr__AEyi+","mobilecontent":"shareableLinks_mobilecontent__HO2qt"};